



































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloMailSkin, getDefaultAloMailSkin } from '@/models/alo/AloMailSkin'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import Edit from '@/components/administration/mailSkin/edit/EditConfig.vue'

@Component({
  name: 'GestionMailSkin',
  components:{Edit} 
})
export default class GestionMailSkin extends Vue {
  private loading = false
  private showError = false    
  private newMailSkin = getDefaultAloMailSkin()

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - 95
  }

  private headers = [
    { text: 'ID', value: 'id', width:70 },    
    { text: 'Titre', value: 'libelle' }/*,
    { text: '', value:'actions', width:30, sortable:false,filterable:false}*/
  ]

  private get mailSkinList() {
    return this.$store.myGetters.mailSkinList
  }
  
  private get sortDesc(){
    return this.$store.myGetters.sortMailSkinDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_MAIL_SKIN_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortMailSkinBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_MAIL_SKIN_BY(value)
  }
  
  created() {
    this.loading = true
    this.$store.myActions.ADM_MAIL_SKIN_ENSURE().finally(() => {
      this.loading = false
    })
  } 


  openDetail(item: any) {   
     this.$store.myActions.ADM_MAIL_SKIN_DETAIL_REQUEST(item.id).then(item =>{
       (this.$refs.edit as Edit).edit(item)
     })    
  }

  deleteMailSkin(mailSkin:AloMailSkin) {
     if(mailSkin.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer le skin "${mailSkin.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_MAIL_SKIN_DELETE_REQUEST(mailSkin.id)
        } 
      })          
    } 
  }

  addMailSkin(){    
    this.newMailSkin = getDefaultAloMailSkin();
    (this.$refs.edit as Edit).edit(this.newMailSkin)   
  }
 
}
